import { useQuery } from '@tanstack/react-query'
import useCycleApi from 'common/hooks/useCycleApi'
import { BaseResponse } from 'common/types/api'
import { formatThaiDateWithBuddhistYear } from 'common/utils/date'
import { selectedCycleIdState } from 'modules/pond/stores/atom'
import { useRecoilValue } from 'recoil'

import { shrimpTopupDateTableFilterState } from '../stores/atom'
import { TOPUP_REQUEST_CONFIG } from '.'
import { CycleWithTopupsData, GetSummary, Topup } from './types'
import { getShrimpTopupKey, getShrimpTopupKeyById, getShrimpTopupSummary } from 'common/constants/queryKeys'

export const useGetShrimpTopup = () => {
  const cycleApi = useCycleApi()
  const date = useRecoilValue(shrimpTopupDateTableFilterState)
  const cycleId = useRecoilValue(selectedCycleIdState)
  const initParams = {
    params: {
      date: date ? formatThaiDateWithBuddhistYear(date) : '',
    },
    cycleId,
  }

  return useQuery({
    queryKey: getShrimpTopupKey(cycleId || '', date),
    queryFn: async ({ pageParam = initParams }) => {
      const { data } = await cycleApi.request<BaseResponse<CycleWithTopupsData>>({
        ...TOPUP_REQUEST_CONFIG.get,
        ...pageParam,
      })
      return data.data
    },
    staleTime: Infinity,
    enabled: !!cycleId,
    refetchOnMount: 'always',
  })
}

export const useGetShrimpTopupById = (shrimpTopupId: string) => {
  const cycleApi = useCycleApi()
  const cycleId = useRecoilValue(selectedCycleIdState)

  return useQuery({
    queryKey: getShrimpTopupKeyById(cycleId || '', shrimpTopupId),
    queryFn: async () => {
      const { data } = await cycleApi.request<BaseResponse<Topup>>({
        ...TOPUP_REQUEST_CONFIG.getById,
        url: `${TOPUP_REQUEST_CONFIG.getById.url}/${shrimpTopupId}`,
      })
      return data.data
    },
    staleTime: Infinity,
    enabled: !!cycleId,
    refetchOnMount: 'always',
  })
}

export const useGetShrimpTopupSummary = () => {
  const cycleApi = useCycleApi()
  const cycleId = useRecoilValue(selectedCycleIdState)

  return useQuery({
    queryKey: getShrimpTopupSummary(cycleId || ''),
    queryFn: async () => {
      const { data } = await cycleApi.request<BaseResponse<GetSummary>>({
        ...TOPUP_REQUEST_CONFIG.getSummary,
      })
      return data.data
    },
    staleTime: Infinity,
    enabled: !!cycleId,
    refetchOnMount: 'always',
  })
}